import React, { useState, useEffect } from "react";
import img from "../images/image1.png";

export const SlideIn = () => {
	const [SlideInStatus, setSlideInStatus] = useState(false);
	useEffect(() => {
		const el = document.getElementsByClassName("SlideInHidden")[0];
		const observ = new IntersectionObserver(([entry]) => {
			setSlideInStatus(entry.isIntersecting), { root: el, threshold: 1.0 };
			entry.isIntersecting === true ? observ.disconnect() : null;
		});
		observ.observe(el);
	}, []);

	return (
		<div
			id="SlideIn"
			className={SlideInStatus === false ? "SlideInHidden" : "SlideInShown"}
		>
			<img src={img} />
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/SlideIn.js